<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
          ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
          แบบยื่นรายการภาษีเงินได้หัก ณ ที่จ่าย
        </div>
        <v-divider />
        <v-dialog v-model="pdfDialog">
          <div>
            <iframe class="iframe" :src="pdfSrc"></iframe>
          </div>
        </v-dialog>
        <v-card class="pa-4" style="height: 600px; max-height: 600px;">
            <div class="tw-grid tw-grid-cols-2 tw-max-w-xl tw-gap-4">
              <span class="mr-3 span-w">ประเภท ภ.ง.ด</span>
                <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                 v-model="selectedTaxWHCode"
                  :items="taxWHCode"
                  item-text="description"
                  item-value="code"
                  outlined
                 dense
                 hide-details
                 label="เลือกประเภท ภ.ง.ด"
                ></v-select>
                <span class="mr-3 span-w">สาขากิจการ</span>
                <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  v-model="selectedBranch"
                  :items="taxWHBranch.branch"
                  item-text="code"
                  item-value="code"
                  v-on:change="onBranchSelect"
                  outlined
                  dense
                  hide-details
                  return-object
                  label="เลือกสาขากิจการ"
                ></v-select>
                <span class="mr-3 span-w">WHT Period</span>
                <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  :items="hierarchicalPeriods"
                  item-text="name"
                  item-value="id"
                  v-model="selectedPeriod"
                  return-object
                  ref="selectMenu"
                  outlined
                  dense
                  label="เลือก WHT Period"
                  hide-details
                >
                  <template v-slot:item="{ item, props }">
                    <v-list-item
                      v-bind="props"
                      :class="getColorClass(item)"
                      :disabled="item.level === 0 || item.level === 1"
                      @click="handleSelectionAndCloseMenu(item)"
                    >
                    <v-list-item-title :style="{ fontWeight: item.level === 0 ? 'bold' : 'normal' }">
                      <span :style="{ 
                paddingLeft: `${item.level * 20}px`, 
                opacity: 1,
                color: item.level === 0 ? '#1976D2' : 'black',
                fontWeight: item.level === 0 ? 'bold' : 'normal'
              }">
                {{ item.name }}
              </span>
                    </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              <span class="mr-3">WHT Filing Status</span>
                <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                  :items="fillingStatus"
                  item-text="statusName"
                  v-model="selectedFillingStatus"
                  return-object
                  outlined
                  dense
                  label="เลือก WHT Filing Status"
                  hide-details
                >
                </v-select>
              <template v-if="isSelectedAdditionalFillingStat">
                <span class="mr-3">เงินเพิ่ม (ถ้ามี)</span>
                <v-text-field
                    v-model="additionalFillingAmount"
                    class="align-right"
                    outlined
                    dense
                    hide-details
                    placeholder="0.00"
                    type="number"
                    hide-spin-buttons
                >
                </v-text-field>
              </template>
                  <div class="d-flex flex-column flex-sm-row justify-space-between tw-col-span-2">
                    <v-btn  :class="{ 'small': isSmallScreen }" color="primary" class="white--text" @click="onClickWHT(selectedTaxWHCode)">
                      <v-icon left>mdi-printer</v-icon>
                      <span class="mx-2">|</span>
                      แบบยื่นรายการ (PDF)
                    </v-btn>

                    <v-btn  :class="{ 'small': isSmallScreen }" color="primary" class="white--text" @click="onClickAttach(selectedTaxWHCode)">
                      <v-icon left>mdi-printer</v-icon>
                      <span class="mx-2">|</span>
                      ใบแนบ (PDF)
                    </v-btn>

                    <v-btn
                        :class="{ 'small': isSmallScreen }"
                        @click="exportTextFile(selectedTaxWHCode)"
                        class="white--text"
                        color="primary"
                        :loading="isExporting"
                        :disabled="isExporting"
                    >
                      <v-icon left>mdi-printer</v-icon>
                      <span class="mx-2">|</span>
                      <span v-if="!isExporting">Text File</span>
                      <span v-else>Exporting...</span>
                    </v-btn>
                  </div>
              </div>

<!--          <CircularProgress-->
<!--            ref="loadingSpinner"-->
<!--            :percentage="progress.percentage"-->
<!--            :showTrigger="false"-->
<!--            overlayPosition="bottom"-->
<!--            :message="progress.message"-->
<!--            @visibility-change="onVisibilityChange"-->
<!--            :size=300-->
<!--          />-->


        </v-card>
        <!-- <v-progress-linear
          indeterminate
          color="green"
          :active="downloadPdfLoading"
        ></v-progress-linear> -->

        <v-snackbar
          v-model="snackbar"
          top
          :color="snackbarColor"
          timeout="2000"
          class="tw-text-center"
        >
      {{ snackbarText }}
    </v-snackbar>
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
// import CircularProgress  from '@/components/public/circular-progress.vue';
import isMobile from "../../libs/detectMobile";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import { mapState } from "vuex";
const _ = require("lodash");
const {v4: uuidv4} = require('uuid');
const axios = require("axios");
const moment = require('moment');

export default {
  data() {
    return{
        taxWHCode: [
          { code: "2", description: "ภ.ง.ด.3" , active: false },
          { code: "1", description: "ภ.ง.ด.53" , active: true}
        ],
        mapType : {
          "2": "ภ.ง.ด.3",
          "1": "ภ.ง.ด.53"
        },
        progress: {
          status: '',
          message: '',
          percentage: 0,
        },
        jobId: null,
        error: '',
        loadingProgress: 0,
        selectedTaxWHCode: "1",
        selectedBranch: null,
        selectedPeriod: null,
        selectedStartDate: null,
        selectedEndDate: null,
        downloadPdfLoading: false,
        isGenerating : false,
        pdfDialog: false,
        pdfSrc: "",
        searchData: null,
        isExporting: false,
        attachSheetPage: 6 ,
        snackbar: false,
        snackbarText: "",
        snackbarColor: "success",
        isSmallScreen: false,
        unsubscribeWHT: null,
        unsubscribeAttach: null,
        periodMonths: null,
      periodYear: null,
      selectedFillingStatus: null,
      fillingStatus: [],
      additionalFillingAmount: 0,
    }
  },
  name: "WithholdingIncomTax",
  components: {
    Admin,
  },
  created() {
    this.getTimePeriods();
    this.getTaxWHBranch();
   // this.getCompanyDetail();

  },
  mounted() {
    this.updateScreenSize();
    this.getFillingStatus();
    window.addEventListener('resize', this.updateScreenSize);
  },
  beforeDestroy() {
    if (this.unsubscribeWHT) {
      this.unsubscribeWHT();
      this.unsubscribeWHT = null;
    }
    if (this.unsubscribeAttach) {
      this.unsubscribeAttach();
      this.unsubscribeAttach = null;
    }
    window.removeEventListener('resize', this.updateScreenSize);
  },
  methods: {
    onVisibilityChange(visible) {
      this.isGenerating = visible;
    },

    updateScreenSize() {
      this.isSmallScreen = window.innerWidth < 600;
    },
    getColorClass(item) {
      if (item.type === 'quarter') {
        return 'bg-quarter';
      } else if (item.type === 'year') {
        return '';
      }
      return '';
    },
    handleSelection(item) {
      if (item) {
        this.selectedStartDate = item.startDate;
        this.selectedEndDate = item.endDate;
        const date = new Date(item.startDate.seconds * 1000);
        this.periodMonths = date.getMonth() + 1;
        this.periodYear = date.getFullYear();
        console.log('this period is ' + this.periodMonths)
        console.log('this period year is ' + this.periodYear)
        console.log('Selected period:', item.name);
        console.log('Selected start date:', this.getDateWithFormat(this.selectedStartDate));
        console.log('Selected end date:', this.getDateWithFormat(this.selectedEndDate));
      }
    },
    onBranchSelect(branch) {
      if (branch) {
        this.selectedBranch = branch
      }
    },
    getDateWithFormat(timestamp) {
      if(!timestamp) return
      // Convert Firebase timestamp to milliseconds
      const seconds = timestamp._seconds || timestamp.seconds || 0;
      const nanoseconds = timestamp._nanoseconds || timestamp.nanoseconds || 0;

      // Convert the timestamp to milliseconds
      const milliseconds = seconds * 1000 + Math.floor(nanoseconds / 1000000);

      // Create a JavaScript Date object from milliseconds
      const date = new Date(milliseconds);

      const parsedDate = moment(date);

      const date_pay = parsedDate.format('D');

      const month_pay = parsedDate.format('MMMM');

      const year_pay = parsedDate.format('YYYY');
      const time_pay = parsedDate.format('HH:mm:ss');

      return `${date_pay}-${month_pay}-${year_pay} ${time_pay}`

    },
    handleSelectionAndCloseMenu(item) {
    this.selectedPeriod = item.id;
    this.handleSelection(item);
    this.$refs.selectMenu.blur();
    },

    exportTextFile(WHCode) {
      if (!this.selectedStartDate || !this.selectedEndDate) {
        this.snackbar = true
        this.snackbarColor = "red"
        this.snackbarText = "Please select Periods before exporting."
        return;
      }
      this.isExporting = true;
      this.isGenerating = true;

      this.getDocsThaiSm()
        .then((data) => {
          let textContent = "";

          // Add data rows without header, including index
          data.forEach((item, index) => {
            let textAddrr = item.payeeAddress;
            if (/\r|\n/.test(textAddrr)) {
                textAddrr = textAddrr.replace(/[\r\n]+/g, ' ');
            }

            let addressParts = textAddrr.match(/.{1,100}/g) || [];

            textContent += `${index + 1}|${item.payeeTaxId ?? ''}|${item.entityBranch ?? ''}||${item.payeeName ?? ''}|||${addressParts[0] ?? ''}|${addressParts[1] ?? ''}|${item.items?.[0]?.taxWHDocDate ?? ''}|${item.items?.[0]?.taxWHDesc ?? ''}|${item.items?.[0]?.taxWHRate ?? ''}|${item.items?.[0]?.taxWHBaseAmount ?? ''}|${item.items?.[0]?.taxWHAmount ?? ''}|${item.items?.[0] ? item.taxWHCondition ?? '' : ''}|${item.items?.[1]?.taxWHDocDate ?? ''}|${item.items?.[1]?.taxWHDesc ?? ''}|${item.items?.[1]?.taxWHRate ?? ''}|${item.items?.[1]?.taxWHBaseAmount ?? ''}|${item.items?.[1]?.taxWHAmount ?? ''}|${item.items?.[1] ? item.taxWHCondition ?? '' : ''}|${item.items?.[2]?.taxWHDocDate ?? ''}|${item.items?.[2]?.taxWHDesc ?? ''}|${item.items?.[2]?.taxWHRate ?? ''}|${item.items?.[2]?.taxWHBaseAmount ?? ''}|${item.items?.[2]?.taxWHAmount ?? ''}|${item.items?.[2] ? item.taxWHCondition ?? '' : ''}\n`;
          });

          const blob = new Blob([textContent], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);

          const today = new Date();
          const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
          const a = document.createElement('a');
          a.href = url;

          a.download = `${WHCode == '1' ? 'ภ.ง.ด.53' : 'ภ.ง.ด.3'}-${this.selectedBranch['companyName'] || ''}-${formattedDate}.txt`;

          document.body.appendChild(a);
          a.click();

          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          this.isExporting = false;
          this.isGenerating = false;
        })
        .catch((error) => {
          console.error("Error during export:", error);
          this.snackbar = true
          this.snackbarColor = "red"
          this.snackbarText = `${error.message || "An error occurred while exporting data. Please try again."}`
          this.isExporting = false;
          this.isGenerating = false;
        });

        this.selectedPeriod = null
        this.selectedStartDate = null
        this.selectedEndDate = null
    },

    onClickWHT: async function (selectedTaxWHCode) {
      console.log("this is TaxWHCode :", selectedTaxWHCode);
      console.log('this is periods :', this.selectedPeriod);
      try {
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        this.isGenerating = true;
        this.progress = {
          status: '',
          message: '',
          percentage: 0,
        };



        if (!['1', '2'].includes(selectedTaxWHCode)) {
          throw new Error("Invalid tax code selected");
        }

        let data;
        if (['1', '2'].includes(selectedTaxWHCode)) {
          if (!this.selectedStartDate || !this.selectedEndDate) {
            throw new Error("Please select Periods before exporting.");
          }
          data = await this.getDocsThaiSm();
        }
        let type = (selectedTaxWHCode === '1' || selectedTaxWHCode === '2') ? selectedTaxWHCode : undefined;

        // Generate jobId on client
        const jobId = uuidv4();
        await this.$store.dispatch("setGlobalLoading", true);
        // Send jobId to API
       await this.updateWHIncomeTaxReturn(data, type, jobId , this.periodMonths)
          .then(result => {
            if (!result?.linkPdf) {
              throw new Error("PDF link not found");
            }
            console.log("link:: ", result.linkPdf);
          })
          .catch(error => {
            console.error("Error in updateWHIncomeTaxReturn:", error);
            this.snackbar = true;
            this.snackbarColor = "red";
            this.snackbarText = `${error.message}`;
            this.isGenerating = false;
            this.downloadPdfLoading = false;
          });

        // if (!link) {
        //   throw new Error("PDF link not found");
        // }

        //console.log("link:: ", link);

        const companyID = this.$route.params.companyId; // Replace with actual company ID
        const docPath = `Companies/${companyID}/SettingThaiSmartTax/taxPdfProgress/WHIncomeTaxReturnPDF/${jobId}`;

        // Set up Firestore listener with known jobId
        this.unsubscribeWHT = fc.db.doc(docPath).onSnapshot(
          (doc) => {
            if (doc.exists) {
              const data = doc.data();
              this.progress.status = data.status;
              this.progress.message = data.message;
              this.progress.percentage = data.percentage;
              //console.log('this is progress', this.progress);

              if (data.status === 'Completed') {
                this.isGenerating = false;
                //
                this.downloadPdfLoading = false;
                this.linkPdf = data.linkPdf;
                if (this.unsubscribeWHT) {
                  this.unsubscribeWHT();
                  this.unsubscribeWHT = null;
                }
                if (!this.pdfDialog && this.linkPdf) {
                  axios.get(this.linkPdf, { responseType: "arraybuffer" })
                    .then((response) => {
                      let url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                      if (isMobile()) {
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        a.download = `${this.mapType[type]}` + new Date().getTime() + ".pdf";
                        a.click();
                        window.URL.revokeObjectURL(url);

                      } else {
                        this.pdfSrc = url;
                        this.pdfDialog = true;

                      }
                      this.$store.dispatch("setGlobalLoading", false);

                    })
                    .catch((error) => {
                      console.log(error);

                    });
                }
              } else if (data.status === 'Error') {
                this.isGenerating = false;
                this.error = data.message;

                this.snackbar = true;
                this.snackbarColor = "red";
                this.snackbarText = `${this.error}`;
                this.downloadPdfLoading = false;
                if (this.unsubscribeWHT) {
                  this.unsubscribeWHT();
                  this.unsubscribeWHT = null;
                }
              }
            }
          },
          (error) => {
            console.error("Error listening to progress:", error);
            this.error = 'Failed to listen to progress updates';

            this.snackbar = true;
            this.snackbarColor = "red";
            this.snackbarText = `${this.error}`;
            this.isGenerating = false;
            this.downloadPdfLoading = false;
          }
        );

      } catch (error) {
        console.error("Error in onClickWHT:", error);

        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        this.periodMonths = null;

      }
    },

    updateWHIncomeTaxReturn: async function (paramdata , type ,jobId , Months) {

      if(!paramdata){
        return
      }
      this.$store.dispatch("setGlobalLoading", true);

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // console.log('this is periode', Months);
      let data = {
        companyID: this.$route.params.companyId,
        type: type, // 1=WHT53 ,2=WHT3 , 3=ATT53 , 4=ATT3
        jobId: jobId,
        data: {
            items: [...paramdata],
            companyDetail: { ...this.selectedBranch  , periodMonths : Months, periodYear: this.periodYear },
            "@PdfWH53Default": 'gs://sld-etax.appspot.com/NsPDF/02.WHT53.pdf',
            "@PdfWH3Default": 'gs://sld-etax.appspot.com/NsPDF/04.WHT03.pdf',
            "@PdfAttach53Default": 'gs://sld-etax.appspot.com/NsPDF/03.attach53.pdf',
            "@PdfAttach3Default": 'gs://sld-etax.appspot.com/NsPDF/05.attach03.pdf',
            fillingStatus: this.selectedFillingStatus,
            additionalFillingAmount: this.additionalFillingAmount || 0
          }
        };
      console.log(data)

      const promise = new Promise((resolve, reject) => {
        axios
          .post(fc.cloudFunctionUrl + "updateWHIncomeTaxReturn", data, { headers })
          // .post('http://127.0.0.1:5001/sld-etax/us-central1/' + "updateWHIncomeTaxReturn", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
              this.$store.dispatch("setGlobalLoading", false);
              this.downloadPdfLoading = false;
            }
          );
      });
      return promise;
    },
    onClickAttach: async function (selectedTaxWHCode) {
      console.log("🚀 ~ selectedTaxWHCode:", selectedTaxWHCode);
      try {
        this.downloadPdfLoading = true;
        this.pdfSrc = null;
        this.isGenerating = true;
        this.progress = {
          status: '',
          message: '',
          percentage: 0,
        };


        if (!['1', '2'].includes(selectedTaxWHCode)) {
          throw new Error("Invalid tax code selected");
        }

        let data;
        if (['1', '2'].includes(selectedTaxWHCode)) {
          if (!this.selectedStartDate || !this.selectedEndDate) {
            throw new Error("Please select Periods before exporting.");
          }
          data = await this.getDocsThaiSm();
        }
        let type = (selectedTaxWHCode === '1') ? '3' : (selectedTaxWHCode === '2') ? '4' : undefined;

        // Generate jobId on client
        const jobId = uuidv4();

        // Send jobId to API without awaiting
        this.updateWHIncomeTaxReturn(data, type, jobId)
          .then(result => {
            if (!result?.linkPdf) {
              throw new Error("PDF link not found");
            }
            console.log("link:: ", result.linkPdf);
          })
          .catch(error => {
            console.error("Error in updateWHIncomeTaxReturn:", error);

            this.snackbar = true;
            this.snackbarColor = "red";
            this.snackbarText = `${error.message}`;
            this.isGenerating = false;
            this.downloadPdfLoading = false;

          });

        const companyID = this.$route.params.companyId; // Replace with actual company ID
        const docPath = `Companies/${companyID}/SettingThaiSmartTax/taxPdfProgress/WHIncomeTaxReturnPDF/${jobId}`;

        // Set up Firestore listener with known jobId
        this.unsubscribeAttach  = fc.db.doc(docPath).onSnapshot(
          (doc) => {
            if (doc.exists) {
              const data = doc.data();
              this.progress.status = data.status;
              this.progress.message = data.message;
              this.progress.percentage = data.percentage;
              console.log('this is progress', this.progress);

              if (data.status === 'Completed') {
                this.isGenerating = false;
                this.downloadPdfLoading = false;
                this.linkPdf = data.linkPdf;
                if (this.unsubscribeAttach ) {
                  this.unsubscribeAttach ();
                  this.unsubscribeAttach  = null;
                }
                if (!this.pdfDialog && this.linkPdf) {
                  axios.get(this.linkPdf, { responseType: "arraybuffer" })
                    .then((response) => {
                      let url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                      if (isMobile()) {
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        a.download = "wht" + new Date().getTime() + ".pdf";
                        a.click();
                        window.URL.revokeObjectURL(url);

                      } else {
                        this.pdfSrc = url;
                        this.pdfDialog = true;

                      }

                    })
                    .catch((error) => {
                      console.log(error);
                    }).finally(() => {
                      this.$store.dispatch("setGlobalLoading", false);
                    });
                }
              } else if (data.status === 'Error') {
                this.isGenerating = false;

                this.downloadPdfLoading = false;
                this.error = data.message;
                this.snackbar = true;
                this.snackbarColor = "red";
                this.snackbarText = `${this.error}`;
                if (this.unsubscribeAttach ) {
                  this.unsubscribeAttach ();
                  this.unsubscribeAttach  = null;
                }
              }
            }
          },
          (error) => {
            console.error("Error listening to progress:", error);
            this.error = 'Failed to listen to progress updates';
            this.isGenerating = false;

            this.snackbar = true;
            this.snackbarColor = "red";
            this.snackbarText = `${this.error}`;
            this.downloadPdfLoading = false;
            this.$store.dispatch("setGlobalLoading", false);

          },

        );

      } catch (error) {
        console.error("Error in onClickAttach:", error);

        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = `${error.message}`;
      } finally {
        this.downloadPdfLoading = false;
        this.selectedPeriod = null;
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        //this.$store.dispatch("setGlobalLoading", false);
      }
    },

    getTimePeriods: function () {
      let companyId = this.$route.params.companyId;
      let year = new Date().getFullYear();
      if (companyId) {
        this.$store.dispatch("thaismartTax/fetchTimePeriods", {
          companyId: companyId,
          year: year,
        });
      }
    },
    getTaxWHBranch: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("thaismartTax/fetchTaxWHBranch", { companyId: companyId })
          .then(() => {
            this.selectedBranch = this.taxWHBranch?.branch[0] || null;
          })
          .catch(error => {
            console.error('Error fetching branches:', error);
          });
      }
    },
    getCompanyDetail: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("companies/getCompany", {
          companyID: companyId,
        });
      }
    },
    getDocsThaiSm: function () {
    return new Promise((resolve, reject) => {
      let companyId = this.$route.params.companyId;
      if (!companyId) {
        reject(new Error("Company ID is missing. Please verify the URL or your company selection."));
        return;
      }

      this.$store.dispatch("thaismartTax/fetchDocsThaiSm", {
        companyId: companyId,
        taxWHCode: this.selectedTaxWHCode,
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        subsidiariesBranch: this.selectedBranch.code
      })
      .then(() => {
        if (this.docsThaiSm && this.docsThaiSm.length > 0) {
          resolve(this.docsThaiSm);
        } else {
          reject(new Error("No results found for the selected criteria. Please adjust your search and try again."));
        }
      })
      .catch((error) => {
        reject(new Error(`Failed to fetch documents: ${error.message}. Please check your network or try again later.`));
      });
    });
    },
    async getFillingStatus() {      // /Companies/CWtzGa8UHAt3gpRLVNxU/SettingThaiSmartTax/taxWHFilingStatusSetting
      const companyId = this.$route.params.companyId;
      const docRef = fc.db.doc(`Companies/${companyId}/SettingThaiSmartTax/taxWHFilingStatusSetting`);
      const doc = await docRef.get();
      console.log("data", doc.data());
      if (doc.exists) {
        const data = (doc.data()?.filingStatuses || []).filter(i=> i.isActive === true);
        this.fillingStatus = data;
        this.selectedFillingStatus = data[0];
      }
    },
    displayAmount(amount) {
      if (typeof amount === "number") {
        return amount?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
      return amount;
    },
  },
  computed: {
      ...mapState({
        selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
        isProductListLoading: (state) => state.companies.isProductListLoading,
        globalLoading: (state) => state.loading.globalLoading,
        periods: (state) => state.thaismartTax.timePeriodsList,
        taxWHBranch: (state) => state.thaismartTax.taxWHBranch,
        docsThaiSm: (state) => state.thaismartTax.docsThaiSm,
        docs: (state) => state.thaismartTax.list,
        //companyDetail:(state) =>state.companies.companyDetail
      }
    ),
    isSelectedAdditionalFillingStat() {
      return this.selectedFillingStatus && this.selectedFillingStatus?.statusName != 'Ordinary Filing';
    },

    hierarchicalPeriods() {
      const years = this.periods
          .filter(period => period.type === 'year')
          .sort((a, b) => {
            const yearA = parseInt(a.name.match(/\d+/)[0], 10);
            const yearB = parseInt(b.name.match(/\d+/)[0], 10);
            return yearB - yearA;
          });
      //console.log("🚀 ~ hierarchicalPeriods ~ years:", years)
      const quarters = this.periods.filter(period => period.type === 'quarter');
      const months = this.periods.filter(period => period.type === 'month');

      return years.flatMap(year => [
        { ...year, level: 0 },
        ...quarters
            .filter(quarter => quarter.parentIndex === year.id)
            .flatMap(quarter => [
              { ...quarter, level: 1 },
              ...months
                  .filter(month => month.parentIndex === quarter.id)
                  .map(month => ({ ...month, level: 2 }))
            ])
      ]);
    },
    totalDocsThaiSm() {
      return this.docsThaiSm.length;
    },
    countSheetAttach(){
      return Math.ceil(this.totalDocsThaiSm / this.attachSheetPage)
    }
  },
  watch: {
    hierarchicalPeriods: {
      handler() {
        if (this.hierarchicalPeriods.length > 0 && !this.selectedPeriod) {
         const now = new Date();
          const currentPeriod = this.hierarchicalPeriods.find(period => {
            return period.type === "month" && period.startDate.seconds <= now.getTime() / 1000 && period.endDate.seconds >= now.getTime() / 1000;

          });
          if (currentPeriod) {
            this.selectedPeriod = currentPeriod.id
            this.handleSelection(currentPeriod);
            console.log('this is current period', currentPeriod)
          }
        }
      },
      deep: true,
    },
  }
};
</script>

<style lang="css" scoped>
.span-w{
  width: 100px;
}
.table-container {
  padding: 1rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

.tr-gray {
  background-color: hsla(0, 0%, 62%, 0.149);
}

.tr-gray-low {
  background-color: hsla(0, 0%, 79%, 0.094);
}

.bot-bg {
  background-color: #133265;
}

.kbank-bg {
  background-color: #00a94f;
}

.ktb-bg {
  background-color: #01a6e6;
}

.bcel-bg {
  background-color: #ec1c24;
}

.bbl-bg {
  background-color: #0065fe;
}

.scb-bg {
  background-color: #4e2a82;
}
.uob-bg {
  background-color: #05377b;
}
.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.detail-table {
  /* border: 2px solid red; */
  height: 60vh;
  overflow-y: auto;
  /* Scrollbar customization */
  /* scrollbar-width: 5px; */
}

/* For WebKit browsers (Chrome, Safari, etc.) */
.detail-table::-webkit-scrollbar {
  width: 3px;
}

.detail-table::-webkit-scrollbar-track {
  background: rgba(231, 231, 231, 0.5);
}

.detail-table::-webkit-scrollbar-thumb {
  background-color: rgb(133, 133, 133);
  border-radius: 20px;
  border: transparent;
}

.table-container table {
  width: 100%;
  margin-bottom: 2rem;
}

.table-container th {
  padding: 8px 5px;
  text-align: left;
  color: #fff;
}

/* Styling for table cells */
.table-container td {
  padding: 10px;
  height: 60px;
}

.small {
  font-size: 12px;
  padding: 6px 12px;
}
.bg-quarter{
  background-color:#B2DFDB ;
}

@media (max-width: 600px) {
  .v-btn {
    flex-grow: 1;
    margin-bottom: 5px;
    justify-content: flex-start;
    min-width: 200px;
    max-width: 250px;
}

  .small{
    font-size: inherit;
    padding: inherit;
  }
}


.align-right >>> input {
  text-align: right;
  padding-top: 14px;
}
</style>
